import { DATA_PRODUCT_SUBSCRIPTIONS_ENDPOINT, DESTINATION_LABELS } from '~/support/constants';

import ApiBase from './ApiBase';

export const BACKFILL_ENDPOINT = 'backfill';
export const BULK_BACKFILL_ENDPOINT = 'backfill/bulk';

export default class DestinationsService extends ApiBase {
  async configureDataProductSubscriptions({ destinationId, selections }) {
    const { data } = await this.client.put(`${destinationId}/${DATA_PRODUCT_SUBSCRIPTIONS_ENDPOINT}`, selections);

    return data;
  }

  async createBulkBackfill(payload) {
    const { data } = await this.client.post(`/${BULK_BACKFILL_ENDPOINT}`, payload);

    return data;
  }

  async createBackfill(payload) {
    const { data } = await this.client.post(`/${BACKFILL_ENDPOINT}`, payload);

    return data;
  }

  async createDestination(payload) {
    const { data } = await this.client.post('', payload);

    return data;
  }

  async deleteDestination(connectionId) {
    const { data } = await this.client.delete(`${connectionId}`);

    return data;
  }

  async editDestination(connectionId, connection) {
    const { data } = await this.client.put(`${connectionId}`, connection);

    return data;
  }

  async fetchAll(params) {
    const { data } = await this.client.get('', { params });

    return data;
  }

  async fetchBackfill(params) {
    const { data } = await this.client.get(`/${BACKFILL_ENDPOINT}`, { params });

    return data;
  }

  async fetchDataProductSubscriptions(id) {
    const { data } = await this.client.get(`${id}/${DATA_PRODUCT_SUBSCRIPTIONS_ENDPOINT}`);

    return data;
  }

  async fetchOne(connectionId) {
    const { data } = await this.client.get(`${connectionId}`);

    return data;
  }

  async fetchProductionDestinations(queryParams) {
    const params = {
      ...queryParams,
      label: DESTINATION_LABELS.production,
    };
    const { data } = await this.client.get('', { params });

    return data;
  }

  async fetchTestDestinations(queryParams) {
    const params = {
      ...queryParams,
      label: DESTINATION_LABELS.test,
    };
    const { data } = await this.client.get('', { params });

    return data;
  }
}
